// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"D1-z"};